import { Box, SwipeableDrawer } from "@mui/material";
import { SyntheticEvent, useEffect, useState } from "react";
import { useStudio } from "../../../context/Studio/useStudio";
import { palette } from "../../../styles/theme";
import StudioLeftSidebar from "../../StudioSidebarContainer/StudioLeftSidebar/StudioLeftSidebar";
import StudioRightSidebar from "../../StudioSidebarContainer/StudioRightSidebar/StudioRightSidebar";
import { useSupportWidget } from "../../../common/hooks/useSupportWidget";

export const MOBILE_RIGHT_SIDEBAR_CONTENT_HEIGHT =
  "calc(70dvh - 95px - 28px - 40px)";

const MobileBottomBar = () => {
  const {
    designState: {
      selection: { selectedPart, ...selection },
      onSelectionChange,
    },
  } = useStudio();
  const { hideWidget, showWidget } = useSupportWidget();
  const [isDrawerOpen, setIsDrawerOpen] = useState(!!selectedPart);

  useEffect(() => {
    setIsDrawerOpen(!!selectedPart); //maybe use selection
  }, [selectedPart, selection]);

  useEffect(() => {
    if (isDrawerOpen) {
      hideWidget();
    } else {
      showWidget();
    }
  }, [isDrawerOpen, hideWidget, showWidget]);

  return (
    <Box display={"flex"}>
      <SwipeableDrawer
        anchor="bottom"
        transitionDuration={500}
        open={isDrawerOpen}
        disablePortal
        data-drawer-body-scrolling="false"
        data-drawer-backdrop="true"
        sx={{
          "& .MuiDrawer-paper::before": {
            content: '""',
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            top: "8px",
            width: "32px",
            height: "4px",
            backgroundColor: palette.grey.darkGrey,
            borderRadius: "2px",
            zIndex: 1,
          },
          "& .MuiBackdrop-root": {
            backgroundColor: "transparent",
          },
        }}
        PaperProps={{
          sx: {
            top: "30dvh",
            overflow: "hidden",
            bottom: "90px",
          },
        }}
        onClose={() => {
          onSelectionChange("", "");
          setIsDrawerOpen(false);
        }}
        onTouchMove={(e: SyntheticEvent) => {
          const target = e.target as HTMLElement;
          const containsRightBar = target.closest(
            ".decoration-right-sidebar-content"
          );
          const containsColorSelectorRightBar = target.closest(
            ".color-selector-right-sidebar-content"
          );
          const containsInchSlider = target.closest(".inch-slider-container");
          if (containsInchSlider) {
            const touch = e.nativeEvent as TouchEvent;
            if (touch.touches.length > 0) {
              const touchMove = touch.touches[0];
              const initialX = 0;
              const initialY = 0;

              const deltaX = Math.abs(touchMove.clientX - initialX);
              const deltaY = Math.abs(touchMove.clientY - initialY);

              if (deltaY < deltaX) {
                e.stopPropagation();
              }
            }
          } else if (containsRightBar || containsColorSelectorRightBar) {
            e.stopPropagation();
          }
        }}
        disableSwipeToOpen
        onOpen={() => setIsDrawerOpen(true)}
      >
        <StudioRightSidebar />
      </SwipeableDrawer>
      <Box
        zIndex={1500}
        sx={{
          backgroundColor: "white",
          borderTop: `1px solid ${palette.grey.lightGrey}`,
          width: "100%",
          minWidth: "100%",
        }}
      >
        <StudioLeftSidebar />
      </Box>
    </Box>
  );
};

export default MobileBottomBar;
